var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nullData"},[_c('img',{attrs:{"src":require("@/assets/imgs/null.png"),"alt":""}}),_c('p',[_vm._v("暂无内容，去其他地方看看吧～")])])
}]

export { render, staticRenderFns }